export const formatDistanceToNow = (date: Date) => {
  const now = new Date();
  const dateObj = new Date(date);
  const diff = now.getTime() - dateObj.getTime();
  const diffInSeconds = Math.floor(diff / 1000);
  const diffInMinutes = Math.floor(diff / (1000 * 60));
  const diffInHours = Math.floor(diff / (1000 * 60 * 60));
  const diffInDays = Math.floor(diff / (1000 * 60 * 60 * 24));

  if (diffInDays > 0) {
    return `${diffInDays}d`;
  }

  if (diffInHours > 0) {
    return `${diffInHours}h`;
  }

  if (diffInMinutes > 0) {
    return `${diffInMinutes}m`;
  }

  return `${diffInSeconds}s`;
};
